var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilePreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#9FA0A7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15518_51475)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0908 10C19.0908 10 15.6817 3.75 9.99991 3.75C4.31809 3.75 0.908997 10 0.908997 10C0.908997 10 4.31809 16.25 9.99991 16.25C15.6817 16.25 19.0908 10 19.0908 10ZM2.24195 10C2.79141 10.8351 3.42337 11.6129 4.12831 12.3216C5.59081 13.7864 7.59082 15.1136 9.99991 15.1136C12.409 15.1136 14.4079 13.7864 15.8726 12.3216C16.5776 11.6129 17.2095 10.8351 17.759 10C17.2095 9.16491 16.5776 8.38714 15.8726 7.67841C14.4079 6.21364 12.4079 4.88636 9.99991 4.88636C7.59082 4.88636 5.59195 6.21364 4.12718 7.67841C3.42222 8.38714 2.79026 9.16491 2.24081 10H2.24195Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9999 7.15882C9.24645 7.15882 8.52385 7.45813 7.99108 7.99091C7.4583 8.52368 7.15899 9.24628 7.15899 9.99973C7.15899 10.7532 7.4583 11.4758 7.99108 12.0086C8.52385 12.5413 9.24645 12.8406 9.9999 12.8406C10.7534 12.8406 11.476 12.5413 12.0087 12.0086C12.5415 11.4758 12.8408 10.7532 12.8408 9.99973C12.8408 9.24628 12.5415 8.52368 12.0087 7.99091C11.476 7.45813 10.7534 7.15882 9.9999 7.15882ZM6.02263 9.99973C6.02263 8.9449 6.44166 7.93326 7.18755 7.18738C7.93343 6.44149 8.94506 6.02246 9.9999 6.02246C11.0547 6.02246 12.0664 6.44149 12.8123 7.18738C13.5581 7.93326 13.9772 8.9449 13.9772 9.99973C13.9772 11.0546 13.5581 12.0662 12.8123 12.8121C12.0664 13.558 11.0547 13.977 9.9999 13.977C8.94506 13.977 7.93343 13.558 7.18755 12.8121C6.44166 12.0662 6.02263 11.0546 6.02263 9.99973Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15518_51475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1818,
    height: 18.1818,
    fill: "white",
    transform: "translate(0.909088 0.90918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePreview);
export default __webpack_public_path__ + "static/media/file-preview.3924c44208cff35a5bc0843d0a979667.svg";
export { ForwardRef as ReactComponent };